import { injectable } from 'inversify';
import { getClientUniqueId } from './engine/analyticsApiClient/helper';

/**
 * Служебные метаданные текущей сессии клиента.
 *
 * Эти данные полезны для диагностики, аналитики и корреляции событий между
 * приложением, каналом и конкретным подключением пользователя.
 */
export interface ClientMetaPayload {
  /** Идентификатор текущего участника в рамках канала, если клиент уже подключён. */
  peerId?: string;
  /** Идентификатор канала, к которому относится текущая сессия. */
  channelId?: string;
  /** Идентификатор приложения LiveDigital, выданный сервером. */
  appId?: string;
  /** Имя датацентра, обслуживающего текущее подключение. */
  datacenterName?: string;
  /** Идентификатор узла, на котором обслуживается соединение. */
  nodeId?: string;
  /** Уникальный идентификатор клиентской сессии для трассировки и аналитики. */
  clUId: string;
  [key: string]: unknown;
}

@injectable()
export class ClientMetaProvider {
  #peerId?: string;

  #channelId?: string;

  #appId?: string;

  #datacenterName?: string;

  #nodeId?: string;

  #externalMeta: Record<string, unknown> = {};

  get meta(): ClientMetaPayload {
    return {
      clUId: getClientUniqueId(),
      ...this.#externalMeta,
      peerId: this.#peerId,
      channelId: this.#channelId,
      appId: this.#appId,
      datacenterName: this.#datacenterName,
      nodeId: this.#nodeId,
    };
  }

  setPeerId(id: string): void {
    this.#peerId = id;
  }

  setChannelId(id: string): void {
    this.#channelId = id;
  }

  setAppId(id: string): void {
    this.#appId = id;
  }

  setDatacenterName(name: string): void {
    this.#datacenterName = name;
  }

  setNodeId(id: string): void {
    this.#nodeId = id;
  }

  setExternalMeta(meta: Record<string, unknown>): void {
    this.#externalMeta = meta;
  }

  clear(): void {
    this.#peerId = undefined;
    this.#channelId = undefined;
    this.#appId = undefined;
    this.#datacenterName = undefined;
    this.#externalMeta = {};
  }
}
